/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Trans } from "react-i18next";

import { api } from "api";

class Navigation extends Component {

  state = {
    GuideStatus: true
  };

  renderLink = (name, path, icon) => {
    if (!this.props.navigation?.find((n) => n.name === path)) return null;
    return (
      <li>
        <Link to={path}>
          <span className={icon}></span> <span>{name}</span>
        </Link>
      </li>
    );
  };

  renderShowHide = (path) => {
    if (!this.props.navigation?.find((n) => n.name === path)) return "none";
  };


  async componentDidMount() {
    if (localStorage.getItem("token"))
      await this.fetchSize()
  }

  fetchSize = async () => {
    try {
      await api.get(`/api/guide/get-guide-center`).then((response) => {
        if (response.data.data.status == 0) {
          this.setState({
            GuideStatus: response.data.data.status,
          });
        }
      })
        .catch((err) => {
          console.error(err);
        }).finally(() => {
        })
    } catch { }
  };


  renderNavigation = () => {
    if (Object.keys(this.props.generalProfile).length === 0) return null;

    // unlisten();
    return (
      <ul className="nav">
        <li>
          <a href="#">
            <Trans desc="Şirket Bilgileri">10024</Trans>
          </a>
          <ul>
            {this.renderLink(
              <Trans desc="Bayi Bilgileri">10031</Trans>,
              "/dealer-info",
              "iconmford fo-icon-info"
            )}
            {this.renderLink(
              <Trans desc="Organizasyon Şeması">10030</Trans>,
              "/organisation",
              "iconmford fo-icon-device-hub"
            )}
            {this.renderLink(
              <Trans desc="Ekibim">10028</Trans>,
              "/my-team",
              "iconmford fo-icon-group"
            )}
            {this.renderLink(
              <Trans desc="Organizsayon Değişimleri">10029</Trans>,
              "/org-activities",
              "iconmford fo-icon-account-balance"
            )}
            {this.renderLink(
              <Trans desc="Rehber">10032</Trans>,
              "/guide",
              "iconmford fo-icon-account-box"
            )}
          </ul>
        </li>
        <li>
          <a href="#">
            <Trans desc="Eğitim ve Gelişim">10025</Trans>
          </a>
          <ul>
            {this.renderLink(
              <Trans desc="Eğitim Takvimi">10034</Trans>,
              "/calendar",
              "iconmford fo-icon-event-note"
            )}
            {this.renderLink(
              <Trans desc="Gelişim Planı">10035</Trans>,
              "/evolution-plan",
              "iconmford fo-icon-work"
            )}
            {this.renderLink(
              <Trans desc="Çalışan Eğitim Yönetimi">10707</Trans>,
              "/employee-training-management",
              "iconmford fo-icon-work"
            )}
            {this.renderLink(
              <Trans desc="Talep Edilen Eğitimlerim">10569</Trans>,
              "/training-requests",
              "iconmford fo-icon-hourglass-empty"
            )}
            {this.renderLink(
              <Trans desc="Yeterlilik">10037</Trans>,
              "/competency",
              "iconmford fo-icon-done-all"
            )}
            {this.renderLink(
              <Trans desc="Bayi Eğitim Potansiyeli">10406</Trans>,
              "/potential-trainings",
              "iconmford fo-icon-airplanemode-active"
            )}
            {this.renderLink(
              <Trans>nav_ford-role-and-authrorize</Trans>,
              "/employee-roles",
              "iconmford fo-icon-extension"
            )}
            {this.renderLink(
              <Trans desc="Eğitime Kayıtlı Çalışanlar">10527</Trans>,
              "/employee-training-registrations",
              "iconmford fo-icon-perm-identity"
            )}
            {this.renderLink(
              <Trans desc="Aldığım Eğitimler">10038</Trans>,
              "/completed-trainings",
              "iconmford fo-icon-school"
            )}
            {this.renderLink(
              <Trans desc="Bilgilendirme Videoları">10058</Trans>,
              "/informational-videos",
              "iconmford fo-icon-school"
            )}
            {/* {this.renderLink(
              <Trans desc="Eğitim Kataloğu">trainingcatalog</Trans>,
              "/training-catalog",
              "icon-icon-menu-achived"
            )} */}
            {this.renderLink(
              <Trans desc="Faturalar">10033</Trans>,
              "/invoices",
              "iconmford fo-icon-monetization-on"
            )}
            {this.renderLink(
              <Trans desc="Eğitim Anketi/Testi">10042</Trans>,
              "/survey",
              "iconmford fo-icon-event-available"
            )}
            {this.renderLink(
              <Trans desc="Aday Havuzu">10598</Trans>,
              "/applicant-pool",
              "iconmford fo-icon-group-work"
            )}
            {this.renderLink(
              <Trans desc="Çalışan 360">employee360_title</Trans>,
              "/employee-360",
              "iconmford fo-icon-public"
            )}
          </ul>
        </li>
        <li style={{ display: this.renderShowHide("/invoices") }}>
          <a href="#">
            <Trans desc="Faturalar">10033</Trans>
          </a>
          <ul>
            {this.renderLink(
              <Trans desc="Faturalar">10033</Trans>,
              "/invoices",
              "iconmford fo-icon-monetization-on"
            )}
            {this.renderLink(
              <Trans desc="Faturalar">applicanttestfeesreport</Trans>,
              "/Invoiceapplicant",
              "iconmford fo-icon-monetization-on"
            )}
            {this.renderLink(
              <Trans desc="Faturalar">employeetestfeesreport</Trans>,
              "/Invoiceemployee",
              "iconmford fo-icon-monetization-on"
            )}
          </ul>
        </li>
        <li>
          <a href="#">
            <Trans desc="Kurumsal">10026</Trans>
          </a>
          <ul>
            {this.renderLink(
              <Trans desc="Vizyon ve Misyon">10039</Trans>,
              "/vision",
              "iconmford fo-icon-collections-bookmark"
            )}
            {this.renderLink(
              <Trans desc="Ford Organizasyon">10040</Trans>,
              "/ford-organization",
              "iconmford fo-icon-device-hub"
            )}
            {this.renderLink(
              <Trans desc="Sıkça Sorulan Sorular">10041</Trans>,
              "/faq",
              "iconmford fo-icon-question-answer"
            )}
            {this.state.GuideStatus != 0 ? this.renderLink(
              <Trans desc="guideTitle">guideTitle</Trans>,
              "/my-guide-center",
              "iconmford fo-icon-event-available"
            ) : null}
          </ul>
        </li>
      </ul>
    );
  };

  render = () => {
    if (this.props.navigation?.length === 0) return null;

    return (
      <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 topMenuNavArea col-lg-5 d-none d-md-block d-lg-block">
        {this.renderNavigation()}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
    navigation: state.profile.general.navigations,
  };
};

export default connect(mapStateToProps, null)(withRouter(Navigation));
